import React from 'react'
import { useTemplateContext } from './Context'
import { EmptyTemplate } from './EmptyTemplate'
import { DataTool } from '../DataTool'
import { Table } from '../Table'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'

export const Layout = () => {
  // the report's filterCategory is the template form's, not the list tool's own filter menu category
  const { components, filterCategory: _filterCategory, ...rest } = useTemplateContext()
  const { list, sort, filter, onChange, height, canAdd, loading, loadMoreEntries, pageInfo } = rest ?? {}

  let heightProps = {}
  if (height) {
    heightProps = {
      height,
      scrollable: true,
    }
  }

  const fields = [{ name: 'name' }, { name: 'description' }]
  let dataToolComponents = null
  if (canAdd) {
    dataToolComponents = { other: components.AddNewTemplateButton }
  }

  return (
    <Stack gap={2}>
      <HorizontalStack className=" justify-content-end">
        <DataTool
          {...{
            filterCategory: undefined,
            searchPlaceHolder: 'Search filter templates',
            components: dataToolComponents,
            fields,
            ...rest,
            initialValues: { value: '{}' },
          }}
          onFilter={null}
        />
      </HorizontalStack>

      <div>
        <Table
          {...{
            ...heightProps,
            loading,
            head: <components.ListHead />,
            emptyContent: <EmptyTemplate />,
            dataArray: list,
            filter,
            sort,
            row: components.ListRow,
            onSelect: onChange,
            selectable: true,
            loadMoreEntries,
            pageInfo,
          }}
        />
      </div>
    </Stack>
  )
}
